<template>
  <div class="home">
    <HomePic :showPic="0"></HomePic>
    <CompanyInfo :showTitle="true" :showRight="false"></CompanyInfo>
<!--    <ProjectList :col="5" :showTitle="true"></ProjectList>-->
<!--    <NewsList :showTitle="true"></NewsList>-->
  </div>
</template>

<script>
import HomePic from '@/components/style1/HomePic.vue';
import CompanyInfo from '@/components/style1/CompanyInfo.vue';

export default {
  name: 'Home',
  components: {
    HomePic, CompanyInfo,
  },
};
</script>
